import Div from "@jumbo/shared/Div/Div";

// This is a fallback component when no data found for the searched request
const FallbackGeneratedFormMessage = () => {
    return (
        <Div
            sx={{
                p: "100px 10px",
                backgroundColor: "#EFEFEF",
                color: "#000"
            }}
        >
            <p>No results found</p>
            <p>Try another search</p>
        </Div>
    );
};

export default FallbackGeneratedFormMessage;